import Translations from "../../../translations";
import Control from "../control";

const BulletinModal = ({ bulletins, showModal, setShowModal }) => {
    return (
        <div className={["modal", showModal == 'bulletin' ? 'show' : 'hide'].join(' ')}>
            <div className="content-modal artigos-background artigosmodal">
                <header>
                    <div className="container">
                        <h2><Translations>modal.bulletin.title</Translations></h2>
                    </div>
                </header>
                <section>
                    <div className="container">
                        <div className="row w-100">
                            <div className="col-md-12">
                                {bulletins.map((item, index) => (
                                    <div className="boxatuacao" key={index} id={`bulletin-${index}`}>
                                        <h3>{item.name}</h3>
                                        <p>{item.description}</p>
                                        {item.link && (
                                            <a href={item.link} target="_blank" rel="noreferrer" className="btn read">
                                                <Translations>modal.bulletin.read</Translations>
                                            </a>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
                <Control
                    showModal={showModal}
                    next={() => {
                        setShowModal('');
                        window.location = '#contato';
                    }}
                    close={() => { setShowModal(''); }}
                    before={() => { setShowModal('articles'); }}
                />
            </div>
        </div>
    );
};

export default BulletinModal;
